export default __webpack_public_path__ + "static/media/two.af2df5de.png";